import { Box } from 'braid-design-system';

import { Context } from './Context';

import * as styles from './Animate.css';

interface Props {
  children: React.ReactNode | (() => React.ReactNode);
  className?: string;
}

export const WhenTrue = ({ className, children }: Props) => (
  <Context.Consumer>
    {({ transition, state }) =>
      state !== 'exited' && (
        <Box
          component="div"
          className={[
            styles.animated,
            styles[transition],
            className ? className : '',
          ]}
        >
          {typeof children === 'function' ? children() : children}
        </Box>
      )
    }
  </Context.Consumer>
);
